import React from 'react';
const Testimonials = () => {
    return (
        <div className="testimonials">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="section-heading">
                            <h2>What members say <em>about us</em></h2>
                            <span>testimonials from our creative community</span>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="owl-testimonials owl-carousel">
                            <div className="testimonial-item">
                                <div className="inner-content">
                                    <h4>Aymen Cherif</h4>
                                    <span>Computer Science Student</span>
                                    <p>"Joining Creative Lab was one of the best decisions I made during my studies at ISI. The Flutter & Mobile Development workshop with trainer Hamed completely changed my perspective on mobile app development. The hands-on approach and collaborative environment helped me build real projects and connect with like-minded peers who share my passion for technology."</p>
                                </div>
                            </div>
                            <div className="testimonial-item">
                                <div className="inner-content">
                                    <h4>Salma Ben Ali</h4>
                                    <span>Software Engineering Student</span>
                                    <p>"The Play4Hope Cup competition was an incredible experience! Creative Lab doesn't just organize technical events - they create opportunities for personal growth and community impact. Participating in both coding competitions and community service projects like the Ramadan iftar taught me that being a good developer means being a good person too. This club truly embodies collaboration and knowledge sharing."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Testimonials;